/** @todo should we assertEvent here? */
export function clearErrors() {
  return {
    errors: [],
  };
}

export default clearErrors;
